<template>
  <div class="school_activity">
    <div class="body container">
      <!--导航-->
      <div class="nav clearfix">
        <a :class="{ active: column.id == columnid }" href="#" v-for="column in brotherColumnData" :key="column.id"
          @click="changeColumn(column.id, column.fix_column_name)">{{ column.title }}</a>

      </div>
      <div class="selectWrap">
        <h4 class="tip">筛选</h4>
        <div class="selectBox">
          <div class="common">
            <span class="text">类型:</span>
            <div class="common-box">
              <a @click="search_active_type(0)" :class="active_type == 0 ? 'active' : ''">全部</a>
              <a @click="search_active_type(1)" :class="active_type == 1 ? 'active' : ''">图片</a>
              <a @click="search_active_type(2)" :class="active_type == 2 ? 'active' : ''">视频</a>
              <a @click="search_active_type(3)" :class="active_type == 3 ? 'active' : ''">文档</a>
              <a @click="search_active_type(4)" :class="active_type == 4 ? 'active' : ''">音频</a>
              <a @click="search_active_type(5)" :class="active_type == 5 ? 'active' : ''">压缩包</a>
            </div>
          </div>
          <div class="common">
            <span class="text">学年:</span>
            <div class="common-box">
              <div class="select-box">
                <el-select v-model="year" placeholder="学年" @change="search()">
                  <el-option v-for="item in this.yearData" :key="item.key" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
                <el-select v-model="term" placeholder="学期" @change="search()">
                  <el-option v-for="item in this.termData" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content wrapper clearfix">
        <div class="resourceBox fl">
          <div class="sortBox clearfix">
            <div class="sort fl">
              <a @click="changeStatus(0)" :class="active1" style="cursor:pointer">全部</a>
              <a @click="changeStatus(1)" :class="active2" style="cursor:pointer">进行中</a>
              <a @click="changeStatus(2)" :class="active3" style="cursor:pointer">已结束</a>
            </div>
            <div class="searchBox fr">
              <span class="des">共{{ this.count }}条结果</span>
              <div>
                <el-input v-model="keyword" placeholder="关键字搜索，标题" class="handle-input mr10 keyword"
                  @keyup.enter.native="search"></el-input>
                <a class="searchBtn" @click="search"></a>
              </div>
            </div>
          </div>
          <div class="noData" v-if="isShow">
            <img src="../../assets/img/no_activity.png" />
            <p>咦？暂时没有师生展评哦~~</p>
          </div>
          <div v-else class="group_box" v-loading="loading">
            <div class="box">
              <div class="item" v-for="(item, index) in this.data" :key="index">
                <div class="item_box">
                  <div class="cover" @click="jumpGroup(item)">
                    <img :src="item.logo" :onerror="errorZpImg" width="100%" height="100%"
                      style="padding: 5px;cursor:pointer" />
                  </div>

                  <p class="line-one">
                    <span class="title" style="width: 150px;cursor:pointer" @click="jumpGroup(item)"
                      :title="item.title">{{ item.title }}</span>
                    <span id="status" style="
                        width: 130px;
                        text-align: right;
                        margin-right: 10px;
                      ">{{ item.cn_status }}</span>
                  </p>
                  <p class="infor">
                    <span id="activity_type" :title="item.work_type"
                      v-if="item.work_type.length > 0">类型：{{ item.work_type.join(",") }}</span>
                    <span id="activity_type" :title="item.work_type" v-if="item.work_type.length == 0">类型：不限</span>
                    <span id="view_count">浏览：{{ item.view_count }}</span>
                    <span id="time">投稿时间：{{
                        item.contribute_begin_time.slice(0, 10)
                      }}--{{ item.contribute_end_time.slice(0, 10) }}</span>
                    <span id="intrdution" :title="item.introduce">简介：{{
                        item.introduce.length > 0 ? item.introduce : "暂无简介"
                      }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <el-pagination v-if="recordcount > page_size" background @size-change="handleSizeChange"
              @current-change="handleCurrentChange" :current-page.sync="page" :page-size="page_size"
              layout="prev, pager, next, jumper" hide-on-single-page style="float: left" :total="recordcount">
            </el-pagination>

            <el-button v-if="recordcount > page_size">确定</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  name: "school_video_weike",
  data() {
    return {
      errorZpImg:
        'this.src="' + require("../../assets/img/zhangpinDf.png") + '"', // 展评
      schoolid: this.$route.query.schoolid,
      isShow: false,
      loading: false,
      columnid: this.$route.query.id, // 栏目id
      active_type: 0, // 活动类型
      activeData: [], // 活动数据
      data: [], // 活动列表数据
      brotherColumnData: [], // 二级导航数据,
      in_process: true, // 进行中
      finished: true, // 已结束
      active1: "active",
      active2: "",
      dfImg: 'this.src="' + require("../../assets/img/zhangpinDf.png") + '"', // 图片损坏默认图
      active3: "",
      page: 1,
      page_size: 15,
      count: 0,
      keyword: "",
      year: "",
      term: "",
      yearData: "",
      termData: [
        {
          value: "0",
          label: "学期",
        },
        {
          value: "1",
          label: "上学期",
        },
        {
          value: "2",
          label: "下学期",
        },
      ],
      user_identity_type: ["不限", "学生", "教师", "不限", "教研员"],
      recordcount: 0,
      has_auth: false,
    };
  },

  components: {},

  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    globalVaranthasInited: function () {
      this.init();
    },
  },

  created() {},

  methods: {
    init() {
      if (globalApi.gWebsiteSessionInfo.logined) {
        this.GetSideBar();
      }
      this.getYearList();
      this.getData();
      this.getBrotherColumn();
    },
    async GetSideBar() {
      let data = {
        s: "WebSchoolAdmin.SideBar.GetSideBar",
      };
      const res = await globalApi.post(data);
      let auth = false;
      if (res.data != undefined && res.data.ret == 200) {
        let list = res.data.data;
        Object.keys(list).forEach(function (key) {
          Object.keys(list[key]["subs"]).forEach(function (key1) {
            if (list[key]["subs"][key1]["title"] == "师生展评") {
              auth = true;
            }
          });
        });
      }
      this.has_auth = auth;
      console.log(this.has_auth);
    },
    //跳转到师生展评
    jumpGroup(item) {
      if (this.has_auth) {
        window.open(
          globalApi.GetWebHost("zhanping") +
            "presentation_info?a_id=" +
            item.activity_id,
          "_blank"
        );
        return;
      }
      if (item.view_scope == 2) {
        //参与者
        if (!globalApi.gWebsiteSessionInfo.logined) {
          this.$message.error("你还没有登录，无法访问！");
        } else {
          this.getActivityInfo(item.activity_id);
        }
      } else if (item.view_scope == 4) {
        //本校
        if (!globalApi.gWebsiteSessionInfo.logined) {
          this.$message.error("你还没有登录，无法访问！");
        } else if (
          globalApi.gWebsiteSessionInfo.userSchoolID == this.schoolid
        ) {
          window.open(
            globalApi.GetWebHost("zhanping") +
              "presentation_info?a_id=" +
              item.activity_id,
            "_blank"
          );
        } else {
          this.getActivityInfo(item.activity_id);
          // this.$message.error("你不是本校成员无法访问！");
        }
      } else {
        //公开
        window.open(
          globalApi.GetWebHost("zhanping") +
            "presentation_info?a_id=" +
            item.activity_id,
          "_blank"
        );
      }
    },
    // 获取展评详情
    async getActivityInfo(id) {
      let data = {
        s: "WebEducationAdmin.WorksShow.getActivityInfo",
        activity_id: id,
      };
      const res = await globalApi.post(data);
      let userid = globalApi.gWebsiteSessionInfo.userid;
      let list = res.data.data.info.rater_list;
      let flag = false;
      //公开投票
      if (res.data.data.info.appraise_type == 2) {
        flag = true;
      }
      if (list.length > 0) {
        list.forEach((row) => {
          if (row.userid == userid) {
            flag = true;
          }
        });
      }
      if (res.data.data.is_contestant || flag) {
        window.open(
          globalApi.GetWebHost("zhanping") + "presentation_info?a_id=" + id,
          "_blank"
        );
      } else {
        this.$message.error("该活动你无访问权限！");
      }
    },
    // 分页导航
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },

    // 获取二级导航接口
    async getBrotherColumn() {
      let data = {
        s: "WebSchoolSpace.Column.GetBrotherColumn",
        columnid: this.columnid,
        weblevel: 1,
        incdisabled: 1,
      };

      let res = await globalApi.post(data);
      this.brotherColumnData = res.data.data;
    },

    // 获取列表数据接口
    async getData() {
      document.documentElement.scrollTop = 0;
      this.loading = true;
      const data = {
        s: "WebEducationSpace.WorksShow.searchActivity",
        edu_id: this.schoolid,
        org_level: 2,
        page: this.page,
        pagesize: this.page_size,
        inc_parent_push: false,
        inc_finished: this.finished,
        inc_living: this.in_process,
        keyword: this.keyword,
        work_type: this.type,
        school_year: this.year,
        term: this.term,
        file_format: this.active_type,
      };
      const response = await globalApi.post(data);
      this.loading = false;
      const res = response.data.data;

      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      this.recordcount = res.recordcount;
      this.count = res.recordcount;
      this.data = res.list;
      this.count == 0 ? (this.isShow = true) : (this.isShow = false);
    },

    // 获取学年接口
    async getYearList() {
      const data = {
        s: "WebSchoolSpace.Common.getYearList",
        gradeid: this.grade,
      };

      const response = await globalApi.post(data);
      const res = response.data.data;

      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }

      this.yearData = res;
    },

    // 关键词搜索
    search() {
      this.page = 1;
      this.getData();
    },

    // 搜索类型
    search_active_type(val) {
      this.active_type = val;
      this.page = 1;
      this.getData();
    },

    // 状态筛选
    // 1-进行中
    // 2-已结束
    // 0-所有
    changeStatus(status) {
      this.page = 1;
      if (status == 1) {
        this.finished = false; // 已结束
        this.in_process = true; // 进行中
        this.active1 = "";
        this.active2 = "active";
        this.active3 = "";
      } else if (status == 2) {
        this.finished = true;
        this.in_process = false;
        this.active1 = "";
        this.active2 = "";
        this.active3 = "active";
      } else {
        this.finished = true;
        this.in_process = true;
        this.active1 = "active";
        this.active2 = "";
        this.active3 = "";
      }
      this.getData();
    },

    // 检查活动状态 显示不同样式
    // 2/3 进行中
    // 4 已结束
    checkStatus(status) {
      if (status == 2 || status == 3) {
        return "status red";
      } else {
        return "status gray";
      }
    },

    // 详情页跳转
    toInfo(a_id) {
      globalApi.jumpPath(4, "presentation_info", "a_id=" + a_id);
    },

    // 二级导航跳转
    changeColumn(id, address) {
      this.$router.push(
        String(
          address + "?id=" + id + "&schoolid=" + this.$route.query.schoolid
        )
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
.keyword {
  width: 90%;
}
.select-box .el-select {
  margin-right: 20px;
}
.school_activity {
  background: #f6f9fa;
  .body {
    .text-hidden {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .nav {
      margin-top: 0;
      padding-top: 20px;
    }
    .wrapper .resourceBox {
      width: 1200px !important;
    }
    .contentWrap {
      display: flex;
      flex-flow: wrap;
      .act_item:hover {
        background: #fff;
      }
      .act_item {
        box-sizing: border-box;
        margin: 22px 0 0;
        padding: 33px 20px;
        width: 600px;
        border-radius: 8px;
        h2 {
          display: flex;
          margin-bottom: 10px;
          line-height: 1.2;
          a {
            font-size: 18px;
            font-weight: bold;
            color: #000;
            max-width: 495px;
            display: inline-block;
          }
          .status {
            font-size: 18px;
            color: #f42e1f;
            font-weight: bold;
          }
        }
        .info {
          color: #999999;
          font-size: 14px;
          margin-bottom: 10px;
          .time {
            color: #0088ff;
          }
        }
        .detail {
          span + span {
            margin-left: 56px;
          }
          font-size: 14px;
          color: #666666;
        }
        img {
          width: 560px;
          height: 336px;
          margin: 10px 0;
          border-radius: 8px;
        }
      }
    }
  }
}

.btnGroup {
  clear: both;
}
.gray {
  color: #555 !important;
}
.act_item h2 a {
  margin-right: 10px;
}
.common-box a {
  cursor: default;
}

.group_box {
  min-width: 1200px;
}
.box {
  margin-left: 16px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  .item {
    width: 220px;
    // height: 380px;
    margin: 0px 13px 10px 0px;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 10px;
    span {
      line-height: 22px;
      margin: 0px 0px 0px 10px;
      // text-align: center;
      font-size: 12px;
      color: #969898;
      font-family: "DIN-Regular";
    }
    .item_box {
      position: relative;
      .cover {
        height: 146px;
        width: 210px;
        // background: #e7ebef;
        border-radius: 4px;
      }
      .line-one {
        margin: 10px 0 8px 0;
        span {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 22px;
          color: rgba(50, 50, 50, 1);
          float: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 10rem;
          margin-left: 3px;
        }
        .stasus {
          float: right;
          margin-right: 5px;
          color: #e94a60;
        }
        .stasus1 {
          float: right;
          margin-right: 5px;
          color: #999999;
        }
        #status {
          float: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 4rem;
          margin-right: 0px;
          color: rgba(238, 118, 135, 1);
        }
      }
      .infor {
        #activity_type {
          float: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 150px;
          margin-left: 2px;
        }
        #member {
          float: left;
          width: 130px;
          text-overflow: ellipsis;
        }
        #view_count {
          position: relative;
          top: -20px;
          float: right;
          width: 75px;
          margin-right: 3px;
          text-overflow: ellipsis;
        }
        #time {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 15rem;
          margin-left: 0px;
        }
        #intrdution {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 10rem;
          height: 50px;
          display: inline-block;
          float: left;
          word-wrap: break-word;
          word-break: break-all;
          margin-left: 0px;
        }
      }
    }
  }
}
</style>
